/**
 * TouchDragOverlay - Visual feedback for touch drag deployment
 * 
 * Shows:
 * - A ghost/preview of the dragged card following the finger
 * - Zone highlighting (left=front, right=flank)
 * - Visual indicator of which zone will receive the deployment
 */

import React from 'react';
import { createPortal } from 'react-dom';
import OrderDesign from '../OrderDesign';
import './TouchDragOverlay.css';

const TouchDragOverlay = ({
  isDragging,
  draggedOrder,
  dragPosition,
  targetZone,
  viewportScale = 1,
}) => {
  if (!isDragging || !draggedOrder) {
    return null;
  }
  
  // Calculate card position (centered on finger)
  const cardWidth = 140;
  const cardHeight = 200;
  const cardX = dragPosition.x - cardWidth / 2;
  const cardY = dragPosition.y - cardHeight - 20; // Position card above finger
  
  return createPortal(
    <div className="touch-drag-overlay">
      {/* Zone highlight overlays */}
      <div 
        className={`touch-drag-zone-highlight left ${targetZone === 'front' ? 'active' : ''}`}
      >
        <div className="zone-label">
          <span className="zone-icon">←</span>
          <span className="zone-name">FRONT</span>
        </div>
      </div>
      
      <div 
        className={`touch-drag-zone-highlight right ${targetZone === 'flank' ? 'active' : ''}`}
      >
        <div className="zone-label">
          <span className="zone-name">FLANK</span>
          <span className="zone-icon">→</span>
        </div>
      </div>
      
      {/* Center dead zone indicator */}
      {!targetZone && (
        <div className="touch-drag-center-indicator">
          <span>Release to cancel</span>
        </div>
      )}
      
      {/* Dragged card preview */}
      <div 
        className="touch-drag-card-preview"
        style={{
          left: cardX,
          top: cardY,
          transform: `scale(${0.7 * viewportScale})`,
          transformOrigin: 'top left',
        }}
      >
        <OrderDesign
          order={draggedOrder}
          count={0}
          minimal={false}
          isOOR={false}
          isSelected={true}
          isPlayable={true}
          scale={0.7}
        />
      </div>
      
      {/* Touch indicator (where finger is) */}
      <div 
        className="touch-drag-finger-indicator"
        style={{
          left: dragPosition.x,
          top: dragPosition.y,
        }}
      />
    </div>,
    document.body
  );
};

export default TouchDragOverlay;

